export default __webpack_public_path__ + "static/media/Discord-Logo-Wordmark-Color.ad18ee14.svg";